/*!
 An experiment in getting accurate visible viewport dimensions across devices
 (c) 2012 Scott Jehl. 
 MIT/GPLv2 Licence
*/

export default function viewportSize() {
	const testElement = document.createElement('div');
	testElement.style.cssText =
		'position: fixed;top: 0;left: 0;bottom: 0;right: 0;';
	document.documentElement.insertBefore(
		testElement,
		document.documentElement.firstChild
	);

	const dimensions = {
		viewportWidth: testElement.offsetWidth,
		viewportHeight: testElement.offsetHeight
	};
	document.documentElement.removeChild(testElement);

	return dimensions;
}



// WEBPACK FOOTER //
// ./src/helpers/viewportSize.js